import angular from 'angular';

SpinnerDirective.$inject = [];

function SpinnerDirective() {
  SpinnerController.$inject = ['$scope'];

  function SpinnerController($scope) {
    $scope.spinner = {
      init: function () {},

      spin: function () {},
    };
    $scope.spinner.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/spinner/spinner.tpl.html',
    scope: {
      spinnerHide: '=?',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
      let count = 0;
      let lCount = 0;
      const word = 'ACME';
      const letters = word.split('');
      const colors = ['#439899', '#f0533f', '#d9aa3d', '#439899'];
      const flip = $($element);
      const flipper = flip.find('.spinner-inner');
      const front = flipper.find('.front');
      const frontLetter = front.find('.letter');
      const back = flipper.find('.back');
      const backLetter = back.find('.letter');

      front.css({ background: colors[count % 4] });
      frontLetter.html(letters[count % letters.length]);

      back.css({ background: colors[count % 4] });
      backLetter.html(letters[count % letters.length]);

      setInterval(function () {
        const deg = ++count * 180;
        const flippedSide = count % 2;
        const flippedLetter = lCount % 2;
        const side = flippedSide ? front : back;
        const letter = flippedLetter ? frontLetter : backLetter;

        side.css({ background: colors[count % 4] });
        letter.html(letters[++lCount % letters.length]);

        flip.toggleClass('hover');
        flipper.css({ transform: 'rotateY(' + deg + 'deg)' });

        console.log(lCount, lCount % letters.length);
      }, 400);
    },

    controller: SpinnerController,
  };
}
export const SpinnerDirectiveModule = angular
  .module('acme.common.directive.spinner', [])
  .directive('spinner', SpinnerDirective).name;
